import React from 'react';
import close from "../../../images/close.svg";
import {useTheme} from "../../../App";
import {useTranslation} from "react-i18next";

const DeleteLicense = ({closeModal, onDelete, licenseName}) => {
  const {isDark} = useTheme()
  const {t} = useTranslation()
  return (
    <div style={{maxWidth: 481}} className={`modal small-modal ${isDark && 'modal__dark'}`}>
      <h5 className="modal__title">{t('deleteLicense')}</h5>
      <button onClick={closeModal} className="modal__close small-modal__close">
        <img src={close} alt=""/>
      </button>
      <p className="modal__text">{t('isDeleteLicense')} “<span className={'font800'}>{licenseName}</span>”?</p>
      <div className="modal__actions mt-40">
        <button onClick={() => {
          onDelete()
          closeModal()
        }} className="delete-button mr-24">
          {t('delete')}
        </button>
        <button onClick={closeModal} className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
          <span className="commonBtn__label">{t('cancel')}</span>
        </button>
      </div>
    </div>
  );
};

export default React.memo(DeleteLicense);
